import { render, staticRenderFns } from "./TeamView.vue?vue&type=template&id=12efeda2&scoped=true"
import script from "./TeamView.vue?vue&type=script&lang=js"
export * from "./TeamView.vue?vue&type=script&lang=js"
import style0 from "./TeamView.vue?vue&type=style&index=0&id=12efeda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12efeda2",
  null
  
)

export default component.exports